import { render } from "./DaySeparator.vue?vue&type=template&id=020d0837&scoped=true&ts=true"
import script from "./DaySeparator.vue?vue&type=script&lang=ts"
export * from "./DaySeparator.vue?vue&type=script&lang=ts"

import "./DaySeparator.vue?vue&type=style&index=0&id=020d0837&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020d0837"]])

export default __exports__